export default __webpack_public_path__ + "static/media/army_63.e73506d1.jpg";